import type { ReactElement } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { PlusPaywall } from 'app/shared-components/PlusPaywall';
import { Button } from '@/components/ui/button';

import { ONBOARDING_PATHS } from './constants/paths';
import { SALES_FEATURES } from './constants/sales-copy';
import { OnboardingLayout } from './components/OnboardingLayout';
import { SalesHeroCarousel } from './components/SalesHeroCarousel';
import { FaqAccordion } from './components/FaqAccordion';
import { useOnboardingTracker } from './hooks/useOnboardingTracker';

interface PlusSalesPageProps {
  organisationId: string;
}

const PlusSalesPage = ({ organisationId }: PlusSalesPageProps): ReactElement => {
  const [searchParams] = useSearchParams();
  const { trackUpsellStarted } = useOnboardingTracker();

  return (
    <OnboardingLayout transparentBg>
      <PlusPaywall
        title="Website Builder"
        description="Launch and modify your site in minutes. Built in website builder - no technical experience needed"
        benefits={SALES_FEATURES}
        benefitColumns={2}
        illustration={<SalesHeroCarousel />}
        organisationId={organisationId}
      >
        <div className="vtwo:flex vtwo:flex-col vtwo:md:flex-row vtwo:items-center vtwo:gap-4 vtwo:rounded-xl vtwo:bg-white/70 vtwo:p-4">
          <p className="vtwo:flex-1 vtwo:text-base vtwo:text-black">
            Start now for free and see what your future website could look like.
          </p>
          <Button
            asChild
            size="xl"
            className="vtwo:bg-featured-cta vtwo:hover:bg-featured-cta-hover vtwo:rounded-lg vtwo:no-underline vtwo:shrink-0"
          >
            <Link
              to={{ pathname: ONBOARDING_PATHS.steps, search: searchParams.toString() }}
              onClick={trackUpsellStarted}
            >
              Start building my website
            </Link>
          </Button>
        </div>
      </PlusPaywall>

      <div className="vtwo:mt-12">
        <FaqAccordion />
      </div>
    </OnboardingLayout>
  );
};

export default PlusSalesPage;
